export const content = {
  totalCard: {
    title: "Итого",
    tradeIn: "Обмен на товар/услугу:",
    sale: "Выкуп за наличные:",
    buttonClient: "ВЫБРАТЬ ПАРТНЁРА",
    titleConfirm: 'Сделка совершена'
  }
}
